import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BaseDataService, HttpResponsesHandlersFactory } from "@bbwt/modules/data-service";
import { IM1ScreenEndpointItem } from "./im1-screen-edpoint";
import { Im1LastUpdateInfo } from "@project/models/im1/im1-last-update-info";
import { IM1UpdateResponse } from "@main/reporting.v3/dashboard/dashboard-models";

@Injectable({
    providedIn: "root"
})
export class IM1DataService extends BaseDataService {
    readonly url = "api/im1-data";

    constructor(http: HttpClient, responsesHandler: HttpResponsesHandlersFactory) {
        super(http, responsesHandler);
    }

    getLastUpdateInfo(patientId: string, endpoint: IM1ScreenEndpointItem) {
        return this.handleRequest(
            this.http.get<Im1LastUpdateInfo>(`${this.url}/${patientId}/last-update/${endpoint}`),
            this.handlersFactory.getDefault({ showErrorMessage: false, showSuccessMessage: false })
        );
    }

    updateInBackground(patientId: string) {
        return this.handleRequest(
            this.http.put<void>(`${this.url}/${patientId}`, null),
            this.handlersFactory.getDefault({ showErrorMessage: false, showSuccessMessage: false })
        );
    }

    async updateIM1DataForDashboard(patientId: string, dashboardId: string, forceUpdate: boolean): Promise<IM1UpdateResponse> {
        return await this.handleRequest(
            this.http.put<IM1UpdateResponse>(`${this.url}/${patientId}/update-im1-data-for-dashboard/${dashboardId}`, forceUpdate),
            this.handlersFactory.getDefault({ showErrorMessage: false, showSuccessMessage: false })
        );
    }
}
